import React from 'react';
/**
 * `MarketingPreferences` renders the marketing preferences section used when
 * saving a quote.
 *
 * It displays a CMS-provided `disclaimer` and a single "Do Not Contact"
 * checkbox bound to `options.doNotContact`.
 */

import Checkbox from './Checkbox/Checkbox';
import { useTranslation } from 'react-i18next';

export type MarketingPreferenceOptions = {
  doNotContact: boolean;
};

export type MarketingPreferencesProps = {
  options: MarketingPreferenceOptions;
  setDoNotContact: (doNotContact: boolean) => void;
  disclaimer: string;
};

const MarketingPreferences = ({
  options,
  setDoNotContact,
  disclaimer
}: MarketingPreferencesProps): JSX.Element => {
  const { t } = useTranslation();

  const onDoNotContactChange = () => {
    setDoNotContact(!options.doNotContact);
  };

  return (
    <>
      <p className='control-label'>{disclaimer}</p>
      <div className='m05-top'>
        <Checkbox
          id='do-not-contact'
          checked={options.doNotContact}
          text={t(
            'customer-product-page.save-quote-confirmation.do-not-contact'
          )}
          onChange={onDoNotContactChange}
        />
      </div>
    </>
  );
};

export default MarketingPreferences;
